(function () {
  const openOmnisendForm = (formId) => {
    if (!formId) return;
    window.omnisend = window.omnisend || [];
    window.omnisend.push(['openForm', formId]);
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-omnisend-form]');
    if (!trigger) return;

    event.preventDefault();
    openOmnisendForm(trigger.getAttribute('data-omnisend-form'));
  });
})();
